import {useLocalObservable} from 'mobx-react'

export const useLoading = (defaultLoading = false) => {
  return useLocalObservable(() => ({
    state: defaultLoading,
    start() {
      this.state = true
    },
    stop() {
      this.state = false
    },
  }))
}
